import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-inconsistencia`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        usuarioExecutante: {
            autocomplete(queryParms) {
                return repository.get(`${baseUrl}/autocomplete-usuario-executante?${urlUtil.serialize(queryParms)}`)
            },
        },
        procedimento: {
            autocomplete(queryParms) {
                return repository.get(`${baseUrl}/autocomplete-procedimento?${urlUtil.serialize(queryParms)}`)
            },
        },
    }
}